import React from 'react';
import classnames from 'classnames';

import styles from './Field.scss';
import RichTextView from 'components/controls/RichTextView';

export default function ({value, fieldName, placeholder = '-', className}) {
    return (
        <RichTextView className={classnames(styles.field, className)}>
            <div className={styles.fieldName}>
                {fieldName}
            </div>
            {value || placeholder}
        </RichTextView>
    );
}


// WEBPACK FOOTER //
// ./src/components/controls/Field.jsx